import { render, staticRenderFns } from "./ordersListTableL.vue?vue&type=template&id=8db857d6&scoped=true"
import script from "./ordersListTableL.vue?vue&type=script&lang=js"
export * from "./ordersListTableL.vue?vue&type=script&lang=js"
import style0 from "./ordersListTableL.vue?vue&type=style&index=0&id=8db857d6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8db857d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8db857d6')) {
      api.createRecord('8db857d6', component.options)
    } else {
      api.reload('8db857d6', component.options)
    }
    module.hot.accept("./ordersListTableL.vue?vue&type=template&id=8db857d6&scoped=true", function () {
      api.rerender('8db857d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/inflowOrderManagement/components/ordersListTableL.vue"
export default component.exports